import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';

function PlayerCard({ player, position }) {
  return (
    <Card className="w-full h-full shadow-lg hover:shadow-xl transition-shadow duration-300">
      <CardHeader className="pb-4">
        {player.image_url && player.image_url.trim() !== '' && (
          <div className="w-full aspect-square relative overflow-hidden rounded-lg mb-4">
            <img 
              src={player.image_url}
              alt={player.name}
              className="object-cover w-full h-full"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
        <h3 className="text-2xl font-bold text-center">{player.name}</h3>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {player.stats && Object.entries(player.stats).map(([key, value]) => (
            <div key={key} className="flex justify-between items-center py-2 border-b border-border last:border-0">
              <span className="text-sm font-medium text-muted-foreground capitalize">
                {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              </span>
              <span className="text-sm font-semibold">
                {typeof value === 'number' ? value.toLocaleString() : value}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default PlayerCard;
